import type { ProfitabilityRow } from '../../financialintel/framework';

type Props = { rows?: ProfitabilityRow[] };

export function ProfitabilityEnginePanel({ rows = [] }: Props) {
  return (
    <div className="grid gap-3 grid-cols-2 sm:grid-cols-4">
      {rows.map((r) => (
        <div key={r.name} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <span className="rounded bg-brand-100 px-1.5 py-0.5 text-xs font-medium text-brand-700 dark:bg-brand-950 dark:text-brand-300">
            {r.level}
          </span>
          <p className="mt-2 font-medium">{r.name}</p>
          <div className="mt-1 flex gap-3 text-sm">
            <span className="text-success-600">{r.margin} margin</span>
            <span className="font-semibold text-brand-600">{r.roi} ROI</span>
          </div>
        </div>
      ))}
    </div>
  );
}
